module.exports = __webpack_public_path__ + "img/person-2_fill.a4023364.svg";